export default __webpack_public_path__ + "static/media/available.231b8b61.svg";